(() => {
  const controls =
    "button, input[type='button'], input[type='submit'], input[type='reset'], .ui-button, a.pagination-button";
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const animations = new WeakMap();
  let pointerPress = null;
  let keyboardPress = null;

  function controlFrom(target) {
    if (!(target instanceof Element)) return null;

    const control = target.closest(controls);
    if (
      !control ||
      control.matches(":disabled, [aria-disabled='true'], [data-disabled='true']")
    ) {
      return null;
    }

    return control;
  }

  function currentScale(control) {
    return parseFloat(window.getComputedStyle(control).scale) || 1;
  }

  function animateScale(control, keyframes, duration, easing = "linear") {
    const previous = animations.get(control);
    previous?.cancel();

    const animation = control.animate(keyframes, {
      duration,
      easing,
      fill: "forwards",
    });
    animations.set(control, animation);
    return animation;
  }

  function press(control) {
    if (reducedMotion.matches || !control.animate) return;

    const from = currentScale(control);
    animateScale(control, [{ scale: from }, { scale: 0.94 }], 110, "ease-out");
  }

  function release(control) {
    if (reducedMotion.matches || !control.animate) {
      animations.get(control)?.cancel();
      animations.delete(control);
      return;
    }

    // A quick tap may end before the press animation paints a frame.
    const from = Math.min(currentScale(control), 0.94);

    // Sample the reference's spring (stiffness 500, damping 28, mass 0.5).
    const stiffness = 500;
    const damping = 28;
    const mass = 0.5;
    const decay = damping / (2 * mass);
    const frequency = Math.sqrt(stiffness / mass - decay * decay);
    const duration = 450;
    const frames = Array.from({ length: 31 }, (_, index) => {
      const progress = index / 30;
      const time = (progress * duration) / 1000;
      const displacement =
        Math.exp(-decay * time) *
        (Math.cos(frequency * time) +
          (decay / frequency) * Math.sin(frequency * time));

      return { scale: 1 + (from - 1) * displacement, offset: progress };
    });
    frames[frames.length - 1].scale = 1;

    const animation = animateScale(control, frames, duration);
    animation.onfinish = () => {
      if (animations.get(control) === animation) {
        animation.cancel();
        animations.delete(control);
      }
    };
  }

  document.addEventListener("pointerdown", (event) => {
    if (event.button !== 0) return;

    const control = controlFrom(event.target);
    if (!control) return;

    pointerPress = { control, pointerId: event.pointerId };
    press(control);
  });

  window.addEventListener("pointerup", (event) => {
    if (pointerPress?.pointerId !== event.pointerId) return;
    release(pointerPress.control);
    pointerPress = null;
  });

  window.addEventListener("pointercancel", (event) => {
    if (pointerPress?.pointerId !== event.pointerId) return;
    release(pointerPress.control);
    pointerPress = null;
  });

  document.addEventListener("pointerout", (event) => {
    if (
      pointerPress &&
      pointerPress.control.contains(event.target) &&
      !pointerPress.control.contains(event.relatedTarget)
    ) {
      release(pointerPress.control);
      pointerPress = null;
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.repeat || (event.key !== " " && event.key !== "Enter")) return;

    const control = controlFrom(event.target);
    if (!control) return;

    keyboardPress = { control, key: event.key };
    press(control);
  });

  document.addEventListener("keyup", (event) => {
    if (keyboardPress?.key !== event.key) return;
    release(keyboardPress.control);
    keyboardPress = null;
  });

  window.addEventListener("blur", () => {
    if (pointerPress) release(pointerPress.control);
    if (keyboardPress) release(keyboardPress.control);
    pointerPress = null;
    keyboardPress = null;
  });
})();
